import API, { APIResponse } from '../index'

export const getFPToken = (): Promise<APIResponse> => {
  return API.request('GET', '/api/v2/fp-token', {}, true)
}

export const getFPProfiles = (): Promise<APIResponse> => {
  return API.request('GET', '/api/v1/user/fp-profiles', {}, true)
}
